import React from 'react';
import GoogleMapReact from 'google-map-react';
import constants from '../constants';

const StoreDetailsMapMarker = ({ children }) => children;

const StoreDetailsMap = (props) => {
    const { lat, lng } = props;

    const storeCoords = {
        lat: parseFloat(lat),
        lng: parseFloat(lng)
    };

    const createMapOptions = maps => {
        return {
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,

            draggable: true,
            scrollwheel: false,
            disableDoubleClickZoom: false,

            clickableIcons: false,
            styles: [
                {
                    stylers: [{ 'visibility': 'on' }]
                }
            ]
        };
    };

    return <div className="store__map">
        <div className="map-wrapper">
            <GoogleMapReact
                bootstrapURLKeys={{ key: constants.googleMapApiKey }}
                defaultCenter={storeCoords}
                defaultZoom={16}
                yesIWantToUseGoogleMapApiInternals={true}
                options={createMapOptions}
            >
                <StoreDetailsMapMarker lat={storeCoords.lat} lng={storeCoords.lng}>
                    <div className="store__map-marker"></div>
                </StoreDetailsMapMarker>
            </GoogleMapReact>
        </div>
    </div>
}

export default StoreDetailsMap;